// extracted by mini-css-extract-plugin
module.exports = {"project_title":"styles_project_title__34mpZ","project_sub_title":"styles_project_sub_title__1wYTx"};